import type { FaireProductEntity } from "../../entity_types/product";

export const p_36ku4zex2r: FaireProductEntity = {
  token: "p_36ku4zex2r",
  type: "product",
  name: "100% That Queen Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/2f4a4150f2fc763506dcbdb04aa28ae5da4e3d47f121ef2d240a7c44d2ed3db5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d27668b8e2b4a75639abb8c25b6d441f2383b9cec4616aae08b5f6a7b7db51b6.jpeg",
    "https://cdn.faire.com/fastly/fc44f887e4c330ede822113b4c881d7fe2ab3cbfae258eeab40745330fe1a949.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/e040de5d2220200964a6eb78a845378920dfa0d30a2035e163c9afca03b34e5b.jpeg",
    "https://cdn.faire.com/fastly/2708782550ba172062f5ebcacc4364f9310cd0cb4c8a2582c8b403c20cb18a81.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nRoyalty is a state of mind, and these socks will get you a step or two closer when you pull them on. Feel the luxury and let your queeny-ness reign supreme! 👑 \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:24.868Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
